/* eslint-disable */

import * as THREE from 'three'

export default {

    uniforms:
    {
        'tDiffuse': { type: 't', value: null },
        'v': { type: 'f', value: 1.0 / 512.0 },
        focal: { type: 'v3', value: new THREE.Vector3(0.5, 0.5, 1) },
        'focalIntensity': { type: 'f', value: 1.0 },
        'focalOffset': { type: 'f', value: 0.0 }
    },

    vertexShader: `
        varying vec2 vUv;

        void main()
        {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
        }
    `,

    fragmentShader: `
        uniform sampler2D tDiffuse;
        uniform float v;
        uniform vec3 focal;
        uniform float focalIntensity;
        uniform float focalOffset;

        varying vec2 vUv;

        void main()
        {
            vec4 blur = vec4( 0.0 );

            blur += texture2D( tDiffuse, vec2( vUv.x, vUv.y - 4.0 * v ) ) * 0.051;
            blur += texture2D( tDiffuse, vec2( vUv.x, vUv.y - 3.0 * v ) ) * 0.0918;
            blur += texture2D( tDiffuse, vec2( vUv.x, vUv.y - 2.0 * v ) ) * 0.12245;
            blur += texture2D( tDiffuse, vec2( vUv.x, vUv.y - 1.0 * v ) ) * 0.1531;
            blur += texture2D( tDiffuse, vec2( vUv.x, vUv.y ) ) * 0.1633;
            blur += texture2D( tDiffuse, vec2( vUv.x, vUv.y + 1.0 * v ) ) * 0.1531;
            blur += texture2D( tDiffuse, vec2( vUv.x, vUv.y + 2.0 * v ) ) * 0.12245;
            blur += texture2D( tDiffuse, vec2( vUv.x, vUv.y + 3.0 * v ) ) * 0.0918;
            blur += texture2D( tDiffuse, vec2( vUv.x, vUv.y + 4.0 * v ) ) * 0.051;

            vec4 diffuse = texture2D( tDiffuse, vUv);

            float distanceToFocal = distance(vec2(focal.x, focal.y), vUv) * focal.z;
            float focalBlur = distanceToFocal * focalIntensity + focalOffset;
            vec4 final = mix(diffuse, blur, focalBlur);

            gl_FragColor = final;
            // gl_FragColor = vec4(focalBlur, 0.0, 0.0, 1.0);
        }
    `
}


// WEBPACK FOOTER //
// ./src/scripts/components/page-home/Background/Shaders/VerticalBlur.js